import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../Table";

type DataTableProps = {
  hasImportanceLevel?: boolean;
  hasWidth?: boolean;
  tableData: {
    columns: {
      key: string;
      label: string;
      className?: string;
      importanceLevel?: number;
      width?: string;
    }[];
    data: {
      [key: string]: string;
    }[];
  };
};

const DataTable = ({
  hasImportanceLevel = false,
  hasWidth = false,
  tableData,
}: DataTableProps) => {
  if (!hasImportanceLevel) {
    tableData.columns = setImportanceLevel(tableData.columns);
  }

  if (!hasWidth) {
    tableData.columns = setWidth(tableData.columns);
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          {tableData.columns.map(
            ({ key, className, importanceLevel, label, ...rest }) => (
              <TableHead
                key={key}
                className={getClassNameBasedOnImportanceLevel(
                  importanceLevel,
                  className,
                )}
                {...rest}
              >
                {label}
              </TableHead>
            ),
          )}
        </TableRow>
      </TableHeader>
      <TableBody>
        {tableData.data.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {tableData.columns.map(({ key, className, importanceLevel }) => (
              <TableCell
                key={key}
                className={getClassNameBasedOnImportanceLevel(
                  importanceLevel,
                  className,
                )}
              >
                {row[key]}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const setImportanceLevel = (columns) => {
  return columns.map((column, index) => {
    if (index === 0 || index === columns.length - 1) {
      return { ...column, importanceLevel: 1 };
    } else if (index === 1 || index === 2) {
      return { ...column, importanceLevel: 2 };
    } else {
      return { ...column, importanceLevel: 3 };
    }
  });
};

const setWidth = (columns) => {
  return columns.map((column, index) => {
    if (index === columns.length - 1) {
      return { ...column, width: "80px" };
    } else {
      return { ...column, width: "200px" };
    }
  });
};

const getClassNameBasedOnImportanceLevel = (
  importanceLevel,
  className = "",
) => {
  switch (importanceLevel) {
    case 3:
      return `${className} hidden 2xl:table-cell`;
    case 2:
      return `${className} hidden lg:table-cell`;
    default:
      return className;
  }
};

export { DataTable };
